import { FC } from "react";

import { parseBoolean } from "@ryde/shared";

import { GreenCheckboxCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const SwitchCellTemplate: FC<IRenderColumnTemplate> = ({ value }) => {
  return <GreenCheckboxCell checked={parseBoolean(value)}></GreenCheckboxCell>;
};
